import { createSelector } from 'reselect';

export const selectApplication = (state) => state.get('application');

const selectRoute = (state) => state.get('route');

export const makeSelectLocation = () => createSelector(
  selectRoute,
  (routeState) => routeState.get('location').toJS()
);

export const lastLocationSelector = createSelector(
  selectRoute,
  (routeState) => {
    const lastLocation = routeState.get('lastLocation');

    if (lastLocation) {
      return lastLocation.toJS();
    }

    return null;
  }
);

export const applicationModeSelector = createSelector(
  selectApplication,
  (application) => application.get('applicationMode'),
);

export const loadPlanFromLinkErrorSelector = createSelector(
  selectApplication,
  (application) => application.get('loadPlanFromLinkError'),
);

export const loadLocalPlanErrorSelector = createSelector(
  selectApplication,
  (application) => application.get('loadLocalPlanError'),
);

export const saveErrorSelector = createSelector(
  selectApplication,
  (application) => application.get('saveError'),
);

export const redirectAfterSaveSelector = createSelector(
  selectApplication,
  (application) => application.get('redirectAfterSave'),
);

export const planLoadingSelector = createSelector(
  selectApplication,
  (application) => application.get('planLoading'),
);

export const priceDifferenceDialogSelector = createSelector(
  selectApplication,
  (application) => application.get('priceDifferenceDialog').toJS(),
);

export const showPlanSavedDialogSelector = createSelector(
  selectApplication,
  (page) => page.get('showPlanSavedDialog'),
);

export const showNewFeaturesDialogSelector = createSelector(
  selectApplication,
  (page) => page.get('showNewFeaturesDialog'),
);

  export const showNewFeaturesToastSelector = createSelector(
  selectApplication,
  (page) => page.get('showNewFeaturesToast'),
);

export const ipexGalleryModeSelector = createSelector(
  selectApplication,
  (ipexGallery) => ipexGallery.get('cwcalcReachedFromIpexGallery'),
);

export const upptackaModeSelector = createSelector(
  selectApplication,
  (upptacka) => upptacka.get('cwcalcReachedFromUpptacka'),
);

export const idleTimeSelector = createSelector(
  selectApplication,
  (ipexGallery) => ipexGallery.get('idleTime'),
);

export const kioskPrintModeSelector = createSelector(
  selectApplication,
  (application) => application.get('printEnabledOnKiosk'),
);
